import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

// Espejo del error que tira lib/api.ts en cualquier respuesta no-2xx.
export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public body?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

// Misma clave que escribe hooks/use-me.ts al confirmar/perder la sesión.
const LAST_USER_KEY = 'redeapp.auth.lastUser';

// Manejo global de sesión caída: cualquier query o mutation que reciba un
// 401 del backend limpia el cache de ['auth','me'] acá, en un solo lugar,
// en vez de repetir la lógica en cada llamado. RequireAuth reacciona al
// cache (data === null) y redirige a /login en el próximo render.
function onSesionRevocada(err: unknown): void {
  if (err instanceof ApiError && err.status === 401) {
    queryClient.setQueryData(['auth', 'me'], null);
    try {
      localStorage.removeItem(LAST_USER_KEY);
    } catch {
      // localStorage bloqueado (modo privado estricto): no es crítico
    }
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: onSesionRevocada,
  }),
  mutationCache: new MutationCache({
    onError: onSesionRevocada,
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, err) => {
        if (err instanceof ApiError && [401, 403, 404].includes(err.status)) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
